export interface ImageDimensions {
  /**
   * The width of the image, in CSS pixels.
   */
  width: number;
  /**
   * The height of the image, in CSS pixels.
   */
  height: number;
  /**
   * The natural width of the image, in physical pixels.
   */
  nativeWidth: number;
  /**
   * The natural height of the image, in physical pixels.
   */
  nativeHeight: number;
}

/**
 * Gets the width and height of an image file.
 */
export function getImageDimensions(image: HTMLImageElement): ImageDimensions {
  return {
    width: Math.round(image.naturalWidth / devicePixelRatio),
    height: Math.round(image.naturalHeight / devicePixelRatio),
    nativeWidth: image.naturalWidth,
    nativeHeight: image.naturalHeight,
  };
}
